import { cn } from '@/lib/utils';

/**
 * Customer tier from Autotask Company → Classification: a one-letter box (E Enterprise, P Premium,
 * H Hybrid, S Standard, L Licensing only). Other classifications have no tier and render nothing.
 * Premium and Enterprise domains must be in dmarcian (Domains page / gap list).
 */
export type Tier = 'E' | 'P' | 'S' | 'H' | 'L';

export const TIER_LABEL: Record<Tier, string> = { E: 'Enterprise', P: 'Premium', H: 'Hybrid', S: 'Standard', L: 'Licensing only' };
/** Display / sort order. */
export const TIER_ORDER: Tier[] = ['E', 'P', 'H', 'S', 'L'];
const TONE: Record<Tier, string> = {
  E: 'border-brand/40 bg-brand-soft text-brand-strong',
  P: 'border-warning/40 bg-warning-soft text-warning',
  H: 'border-info/40 bg-info-soft text-info',
  S: 'border-border bg-muted text-muted-foreground',
  // Purple, so Licensing only never reads as Standard (same violet the client picker uses for CSP).
  L: 'border-violet-400/50 bg-violet-100 text-violet-800 dark:border-violet-400/40 dark:bg-violet-500/20 dark:text-violet-200',
};

export function TierBox({ tier, className, size = 'sm' }: { tier: Tier | null | undefined; className?: string; size?: 'xs' | 'sm' }) {
  if (!tier) return null;
  return (
    <span title={`${TIER_LABEL[tier]} customer`} aria-label={`${TIER_LABEL[tier]} customer`}
      className={cn('inline-flex shrink-0 items-center justify-center rounded border font-bold leading-none tabular-nums',
        size === 'xs' ? 'h-4 w-4 text-[9.5px]' : 'h-[18px] w-[18px] text-[10.5px]', TONE[tier], className)}>
      {tier}
    </span>
  );
}
